import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  IconButton,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';

import { ChevronDownIcon } from '@chakra-ui/icons';
import { HamburgerIcon } from '@chakra-ui/icons';
import { Footer } from '../footer/Footer';

const getUser = () => JSON.parse(sessionStorage.getItem('user'));

const Sidebar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [user] = useState(getUser);

  const renderConsignedPortalMenu = () => {
    return (
      <Menu>
        <MenuButton textAlign="left" as={Button} rightIcon={<ChevronDownIcon />}>
          Portal Consignado
        </MenuButton>
        <MenuList>
          <MenuItem>
            <Link as={RouterLink} to={'/margin'}> Pesquisar Margem </Link>
          </MenuItem>
        </MenuList>
      </Menu>
    );
  }

  const renderBmgBankMenu = () => {
    return (
      <Menu>
      <MenuButton textAlign="left" as={Button} rightIcon={<ChevronDownIcon />}>
        Banco BMG
      </MenuButton>
      <MenuList>
        <MenuItem>
          <Link as={RouterLink} to="/banks/bmg/proposalStatus">Consultar Propostas</Link>
        </MenuItem>
        <MenuItem>
          <Link as={RouterLink} to="/banks/bmg/ComplementaryWithdrawalBenefit">Consultar Saque Complentar Benefício</Link>
        </MenuItem>
        <MenuItem>
          <Link as={RouterLink} to="/banks/bmg/card-limit">Consultar Saque Complentar</Link>
        </MenuItem>
        <MenuItem>
          <Link as={RouterLink} to="/banks/bmg/withdrawalLimit">Consultar Limite de Cartão</Link>
        </MenuItem>
        <MenuItem>
          <Link as={RouterLink} to="/banks/bmg/withdrawalLimitBenefitCard">Consultar Limite de Cartão Benefício</Link>
        </MenuItem>
        <MenuItem>
          <Link as={RouterLink} to="/banks/bmg/loanLimitSimulation">Consultar Limite de Empréstimo</Link>
        </MenuItem>
      </MenuList>
    </Menu>
    );
  }

  const renderSafraBankMenu = () => {
    return (
      <Menu>
        <MenuButton textAlign="left" as={Button} rightIcon={<ChevronDownIcon />}>
          Banco SAFRA
        </MenuButton>
        <MenuList>
          <MenuItem>
            <Link as={RouterLink} to="/banks/safra/agreement">Contrato</Link>
          </MenuItem>
          <MenuItem>
            <Link as={RouterLink} to="/banks/safra/formalization">Formalização</Link>
          </MenuItem>
          <MenuItem>
            <Link as={RouterLink} to="/banks/safra/fgtsBalance">Saldo do FGTS</Link>
          </MenuItem>
          <MenuItem>
            <Link as={RouterLink} to="/banks/safra/simulation">Simulação</Link>
          </MenuItem>
          <MenuItem>
            <Link as={RouterLink} to="/banks/safra/margin">Consultar Margem</Link>
          </MenuItem>
        </MenuList>
      </Menu>
    );
  }

  const renderMasterBankMenu = () => {
    return (
      <Menu>
        <MenuButton textAlign="left" as={Button} rightIcon={<ChevronDownIcon />}>
          Banco MASTER
        </MenuButton>
        <MenuList>
          <MenuItem>
            <Link as={RouterLink} to="/banks/master/loanLimitSimulationCredcesta">Consultar Limite CredCesta</Link>
          </MenuItem>
          <MenuItem>
            <Link as={RouterLink} to="/banks/master/loanLimitSimulationMfacil">Consultar Limite MFácil</Link>
          </MenuItem>
        </MenuList>
      </Menu>
    );
  }

  const renderClientMenu = () => {
    return (
      <Menu>
        <MenuButton textAlign="left" as={Button} rightIcon={<ChevronDownIcon />}>
          Clientes
        </MenuButton>
        <MenuList>
          <MenuItem>
            <Link as={RouterLink} to="/client/check-client">Dados Cadastrais Por CPF</Link>
          </MenuItem>
          <MenuItem>
            <Link as={RouterLink} to="/client/check-client-phone">Dados Cadastrais Por Telefone</Link>
          </MenuItem>
        </MenuList>
      </Menu>
    );
  }

    const renderUserMenu = () => {
    if (user.role) {
      if (user.role === 'ADMINISTRATOR') {
        return (
          <Menu>
            <MenuButton textAlign="left" as={Button} rightIcon={<ChevronDownIcon />}>
              Usuários
            </MenuButton>
            <MenuList>
              <MenuItem>
                <Link as={RouterLink} to="/user">Usuários</Link>
              </MenuItem>
            </MenuList>
          </Menu>
        );
      }
    }
  }

  const renderChatMenu = () => {
    if (user.role) {
      if (user.role === 'ADMINISTRATOR') {
        return (
          <Menu>
            <MenuButton textAlign="left" as={Button} rightIcon={<ChevronDownIcon />}>
              Chat GPT
            </MenuButton>
            <MenuList>
              <MenuItem>
                <Link as={RouterLink} to="/chatgpt">Chat GPT</Link>
              </MenuItem>
            </MenuList>
          </Menu>
        );
      }
    }
  }

  return (
    <>
      {/* Botão para abrir o menu */}
      <IconButton
        icon={<HamburgerIcon />}
        onClick={onOpen}
        zIndex="overlay"
        aria-label="Abrir menu"
      />

      <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">Menu</DrawerHeader>
          <DrawerBody>
            <VStack spacing="4" align="stretch">
              { renderConsignedPortalMenu() }
              { renderBmgBankMenu() }
              { renderSafraBankMenu() }
              { renderMasterBankMenu() }
              { renderClientMenu() }
              { renderUserMenu() }
              { renderChatMenu() }
            </VStack>
          </DrawerBody>
          <Footer />
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default Sidebar;